module.exports = __webpack_public_path__ + "img/3866512.jpg";